import {
  DetailRequirement,
  EngagementTaskTrait,
  MpxResponseMeta,
  Require,
  TaskDataUpdates,
  TaskDetails,
} from '@cibo/core'
import React from 'react'
import { DataEntrySchemaEditingState } from './types'

export const DataEntrySchemaEditingContext = React.createContext<{
  setState(state: DataEntrySchemaEditingState): void
  saveTaskData(
    updates: TaskDataUpdates,
    options?: { onError?: (error: Error) => void }
  ): Promise<(MpxResponseMeta & TaskDetails) | void>
}>({
  setState: () => {},
  saveTaskData: async () => Promise.resolve({} as MpxResponseMeta & TaskDetails),
})

export const useDataEntrySchemaEditing = () => {
  const context = React.useContext(DataEntrySchemaEditingContext)

  return {
    ...context,

    startEditingDetail: ({
      detailRequirement,
      traitConfig,
      fieldIds,
      onSuccess,
    }: {
      detailRequirement?: DetailRequirement
      traitConfig: Require<EngagementTaskTrait, 'schema'>
      fieldIds?: string[]
      onSuccess?: (value: any) => void
    }) => {
      context.setState({
        open: true,
        detailRequirement,
        traitConfig,
        // only field currently supported
        dataType: 'field',
        resourceIds: fieldIds,
        onSuccess,
      })
    },
  }
}
